import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, realTimeBaseURL } from '../../../../Containers/Config/index.js';
import {
  DELETE_GOLF_COURSE_FORMATS_BY_ID,
  DELETE_GOLF_COURSE_FORMATS_BY_ID_SUCCESS,
  DELETE_GOLF_COURSE_FORMATS_BY_ID_ERROR,
} from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';
import cogoToast from 'cogo-toast';

function* deleteGolfCourseFormatsById({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${realTimeBaseURL}/admin/golfcourse-formats/${payload.id}`,
      method: 'DELETE',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);
      yield put({
        type: DELETE_GOLF_COURSE_FORMATS_BY_ID_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: DELETE_GOLF_COURSE_FORMATS_BY_ID_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: DELETE_GOLF_COURSE_FORMATS_BY_ID_ERROR, payload: error });
  }
}

export function* watchDeleteGolfCourseFormatsById() {
  yield takeEvery(DELETE_GOLF_COURSE_FORMATS_BY_ID, deleteGolfCourseFormatsById);
}

function* deleteGolfCourseFormatsByIdSaga() {
  yield all([fork(watchDeleteGolfCourseFormatsById)]);
}

export default deleteGolfCourseFormatsByIdSaga;
